import React, {PureComponent} from 'react';

import {Redirect, Link} from 'react-router-dom';
import toastr from 'toastr';
import {getCurrentUserId, getJwt, login, setCurrentUserName} from '../../services/authService';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';
import FacebookLoginFailedModal from '../modals/FacebookLoginFailedModal';
import Header from './Header';

// import ReactGA from "react-ga";

class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                email: "",
                password: ""
            },
            user: {},
            teams: {},
            teamsIn: {},
            remember_me: true,
            done: false,
            spinnerActive: false,
            errors: {},
            overlayIsOpen: false,
            errorsList: [],
            fieldsCheckActive: false
        };
    }

    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);

        this.getUserData();
        // console.log('href: ', window.location.href)
        // if (window.location.href.includes('plan=')) {
        //     localStorage.setItem('allowedTrial', true)
        //     let plan = window.location.href.split('=')[1]
        //     console.log('predefinedPlan: ', plan);
        //     localStorage.setItem('predefinedPlan', plan)
        // }
    }

    doSubmit = async (type) => {
        type.preventDefault();

        this.setState({fieldsCheckActive: true, spinnerActive: true})
        const {
            email,
            password
        } = this.state.data;
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(async (error) => await error ? anyErrorActive = true : '')
            //console.log("doSubmit this.state.spinnerActive ", this.state.spinnerActive);
            if (!anyErrorActive && email && password) {
                try {
                    await login(email, password);
                    const {state} = await this.props.location;
                    await this.setState({spinnerActive: false});
                    window.location = await state ? state.from.pathname : "/";
                } catch (ex) {
                    // console.log("doSubmit this.state.spinnerActive ", this.state.spinnerActive, ex);
                    toastr.error("Unsuccessful Login. Email and password you entered do not match");
                    if (type === 'facebook') {
                        this.setState({overlayIsOpen: true})
                        // console.log('Evo neke greske: ', type, ex)
                    }
                    this.setState({spinnerActive: false});
                    if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                        const errors_obj = this.state.errors;
                        let errors = {...errors_obj};
                        errors = ex.response.data.errors;
                        this.setState({errors});
                    }
                    if (ex.response && ex.response.status === 401) {
                        const errors_obj = this.state.errors;
                        let errors = {...errors_obj};
                        errors.email = ex.response.data.message;
                        this.setState({errors});
                    }
                }
            } else {
                this.setState({spinnerActive: false})
            }
        }, 500);
    };

    getUserData = async () => {
        const userId = await getCurrentUserId();
        if (getJwt()) {
            try {
                // const user_id = await getCurrentUserId();
                // const result = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
                const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                let teams = '';
                let teamsIn = '';
                try {
                    let teamResult = await http.get('/api/user/' + result.data.data.id + '/teams', {headers: {authorization: getJwt()}});
                    teams = await teamResult.data.teams.data || [];
                    teamsIn = await teamResult.data.teams_in.data || [];
                } catch (ex) {
                    if (ex.response && ex.response.status === 404)
                        //console.log("User Something went wrong... Please refresh and try again.");
                        this.props.history.push('/logout');
                    if (ex.response && ex.response.status === 401) {
                        //    let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        //console.log(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }

                const data = await result.data.data;
                if (data !== this.state.user) {
                    await this.setState({user: data, teams, teamsIn})
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    //console.log("User Something went wrong... Please refresh and try again.");
                    this.props.history.push('/logout');
                if (ex.response && ex.response.status === 401) {
                    //    let errors = { ...this.state.errors }
                    //console.log(ex.response.data);
                    //console.log(ex.response.data.message);
                    //window.location = "/";
                    this.props.history.push('/logout');
                }
            }
        }
    }

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    render() {
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        if (getCurrentUserId() && this.state.user.id) {
            // if (this.getUserData()) {
            //     return <Redirect to="/dashboard"/>
            // }
            this.getUserData();
            if (this.state.user.id) {
                //console.log(this.state.user, this.state.teams)
                if (((this.state.teams && this.state.teams.length) || (this.state.teamsIn && this.state.teamsIn.length)) && (this.state.user.name !== ' ')) {


                    return (
                        // process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                        //         <Redirect to="/dashboard"/>
                        //         :
                        <Redirect to="/channels"/>
                    )


                } else if (this.state.user.name && (this.state.user.name !== ' ')) {
                    return <Redirect to="/insert-company"/>
                } else if (this.state.user.id && this.state.user.name === ' ') {
                    return <Redirect to="/insert-name"/>
                }
            }
        } else if (!getCurrentUserId()) {
            return (
                <div className='onboarding-container'>
                    <Header linkDisabled={true}/>
                    <div className="onboarding-content">
                        <div className="onboarding-panel">
                            <h1 className='onboarding-title'>Log in</h1>
                            <form>
                                <InputRegular
                                    id="1"
                                    label1=""
                                    label2=""
                                    placeholder="name@example.com"
                                    type='email'
                                    onChange={e => this.setState({
                                        data: {
                                            ...this.state.data,
                                            email: e
                                        }
                                    })}
                                    value={this.state.data.email}
                                    updateErrorsList={this.updateErrorsList}
                                    errorMessage="Must be a valid email address"
                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                    required={true}
                                />
                                <InputRegular
                                    id="2"
                                    label1=""
                                    label2=""
                                    placeholder="********"
                                    type='password'
                                    onChange={p => this.setState({
                                        data: {
                                            ...this.state.data,
                                            password: p
                                        }
                                    })}
                                    value={this.state.data.password}
                                    updateErrorsList={this.updateErrorsList}
                                    errorMessage="Check your password"
                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                    required={false}
                                />
                                {!this.state.spinnerActive ?
                                    <button
                                        type='submit'
                                        className="btn-action"
                                        disabled={!this.state.data.email || !this.state.data.password}
                                        onClick={this.doSubmit}
                                    >
                                        Login
                                    </button>
                                    :
                                    <button disabled={true} className="btn-action btn-disabled btn-spinner"
                                            type='submit' onClick={this.doSubmit}>Login <i
                                        className='fa fa-spin fa-spinner'></i>
                                    </button>
                                }
                            </form>
                            <Link className='text-center margin-top-10' to='forgot-password'>Forgot password?</Link>

                            <p className='m-m-b m-m-t text-center'>Or</p>
                            <FacebookLogin
                                appId={facebook_app_id}
                                autoLoad={false}
                                fields="name, email, picture.type(large)"
                                scope="email, public_profile"
                                callback={this.responseFacebook}
                                render={renderProps => (
                                    <button type="button" className="btn-fb" onClick={renderProps.onClick}>
                                        Login with Facebook
                                    </button>)}
                            />

                            <p className='panel-message text-center'>Don't have an account yet? <Link to="/register">Create
                                an
                                account</Link>
                            </p>
                        </div>
                    </div>
                    <FacebookLoginFailedModal
                        showModal={this.state.overlayIsOpen}
                        handleClose={() => this.setState({overlayIsOpen: false})}
                        maxWidth={600}
                    />
                </div>
            )
        } else {
            return (
                <div className='login-loader'>
                    <img src="/img/login-loader.svg" alt="Loading..."/>
                </div>
            )
        }
    }

}

export default Login